<template>
  <div class="section-container">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-sm-offset-2 section-container-spacer">
          <div class="text-center">
            <h1 class="h2">02 : 案例</h1>
          </div>
        </div>
        <!-- 2018年项目 -->
        <WorksCarousel :currentWorks="year2018works" carouselId="year2018works" @setModalWork="changeCurrentWork" />
        <!-- 2018年项目 -->
        <!-- 2016 && 2017年项目 -->
        <WorksCarousel :currentWorks="year201617works" carouselId="year201617works" @setModalWork="changeCurrentWork" />
        <!-- 2016 && 2017年项目 -->
        <!-- 2015年项目 -->
        <WorksCarousel :currentWorks="year2015works" carouselId="year2015works" @setModalWork="changeCurrentWork" />
        <!-- 2015年项目 -->
        <!-- 2014年项目 -->
        <WorksCarousel :currentWorks="year2014works" carouselId="year2014works" @setModalWork="changeCurrentWork" />
        <!-- 2014年项目 -->
        <!-- 2013年项目 -->
        <WorksCarousel :currentWorks="year2013works" carouselId="year2013works" @setModalWork="changeCurrentWork" />
        <!-- 2013年项目 -->
      </div>
      <!-- 案例展示弹窗 -->
      <div class="modal fade work-modal" :class="{ 'mobile-modal': isMobile }" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-xs-12">
                  <div class="section-container-spacer text-center">
                    <h1 class="h2">{{currentWork.name}}</h1>
                  </div>
                  <div class="row">
                    <!-- 左边的图片案例 -->
                    <div class="col-xs-12 col-md-8">
                      <!-- pc端案例展示 -->
                      <template v-if="currentWork.bannerType === 'pc'">
                        <div class="pc-box">
                          <div id="pcCarousel" class="carousel slide" data-ride="carousel">
                            <div class="carousel-inner">
                              <template v-if="currentWork.banner.length">
                                <div class="item" v-for="(item,index) in currentWork.banner" :class="{ 'active' :  index == 0 }">
                                  <img :src="item" />
                                    </div>
                              </template>
                              <template v-else>
                                <div class="item black-image-project-hover active">
                                  <img src="../assets/images/work01-hover.jpg" alt="First slide"></img>
                                </div>
                                <div class="item black-image-project-hover">
                                  <img src="../assets/images/work01-hover.jpg" alt="Second slide"></img>
                                </div>
                                <div class="item black-image-project-hover">
                                  <img src="../assets/images/work01-hover.jpg" alt="Third slide"></img>
                                </div>
                              </template>
                            </div>
                            <a class="left carousel-control" href="#pcCarousel" data-slide="prev">‹</a>
                            <a class="right carousel-control" href="#pcCarousel" data-slide="next">›</a>
                          </div>
                        </div>
                      </template>
                      <!-- pc端案例展示 -->
                      <!-- mobile端案例展示 -->
                      <template v-if="currentWork.bannerType === 'mobile'">
                        <div id="mobileCarousel" class="carousel slide mobile-box" data-ride="carousel">
                          <div class="carousel-inner">
                            <template v-if="currentWork.banner.length">
                              <div class="item" v-for="(item,index) in currentWork.banner" :class="{ 'active' :  index == 0 }">
                                <img :src="item" />
                                  </div>
                            </template>
                            <template v-else>
                              <div class="item black-image-project-hover active">
                                <img src="../assets/images/work01-hover.jpg" alt="First slide"></img>
                              </div>
                              <div class="item black-image-project-hover">
                                <img src="../assets/images/work01-hover.jpg" alt="Second slide"></img>
                              </div>
                              <div class="item black-image-project-hover">
                                <img src="../assets/images/work01-hover.jpg" alt="Third slide"></img>
                              </div>
                            </template>
                          </div>
                          <a class="left carousel-control" href="#mobileCarousel" data-slide="prev">‹</a>
                          <a class="right carousel-control" href="#mobileCarousel" data-slide="next">›</a>
                        </div>
                      </template>
                      <!-- mobile端案例展示 -->
                    </div>
                    <!-- 左边的图片案例 -->
                    <!-- 右边的数据展示 -->
                    <div class="col-xs-12 col-md-4">
                      <h3>案例类型&&日期</h3>
                      <p>{{currentWork.appType}}/{{currentWork.industryType}}--{{currentWork.date}}</p>
                      <template v-if="currentWork.partner">
                        <h3>合作伙伴</h3>
                        <p>{{currentWork.partner}}</p>
                      </template>
                      <h3>案例简述</h3>
                      <p>{{currentWork.describe}}</p>
                      <!-- 跳转按钮 -->
                      <template v-if="currentWork.demoUrls && currentWork.demoUrls.length">
                        <a v-for="item in currentWork.demoUrls" class="btn btn-default" style="margin-right: 15px" :href="item.url" target="_blank">{{ item.intro }}</a>
                      </template>
                      <!-- 跳转按钮 -->
                      <!-- 二维码 -->
                      <template v-if="currentWork.qrLinks && currentWork.qrLinks.length">
                        <div class="qr-item" v-for="(qr,qIdx) in currentWork.qrLinks">
                          <h3>{{qr.title}}</h3>
                          <img class="qr-img" :src="qr.qrImg">
                        </div>
                      </template>
                      <!-- 二维码 -->
                    </div>
                    <!-- 右边的数据展示 -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 案例展示弹窗 -->
    </div>
  </div>
</template>
<script>
import { year2013works, year2014works, year2015works, year201617works, year2018works } from '@/utils/data-source.js'
import { isMobile } from '@/utils/index.js'

import WorksCarousel from '@/components/works-carousel.vue'
export default {
  components: {
    WorksCarousel
  },
  computed: {
    year2013works() {
      return year2013works
    },
    year2014works() {
      return year2014works
    },
    year201617works() {
      return year201617works
    },
    year2015works() {
      return year2015works
    },
    year201617works() {
      return year201617works
    },
    year2018works() {
      return year2018works
    }
  },
  data() {
    return {
      currentWork: {},
      isMobile
    }
  },
  watch: {},
  methods: {
    changeCurrentWork(work) {
      this.currentWork = work

    }
  },
  mounted() {
    navActivePage();
  },
}
</script>
<style lang="scss">
.work-modal {
  .qr-img {
    width: 150px;
  }

  .pc-box {
    width: 600px;
    height: 375px;
    margin: auto;
    background-image: url('../assets/images/work/pc-box.png');
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;

    #pcCarousel {
      width: 407px;
      height: 242px;
      position: absolute;
      left: 100px;
      top: 40px;
    }

    #pcCarousel .carousel-inner {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    .left.carousel-control {
      left: -76px;
    }

    .right.carousel-control {
      right: -76px;
    }
  }

  .mobile-box {
    width: 500px;
    height: 500px;
    margin: auto;
    position: relative;

    &:after {
      position: absolute;
      z-index: 1;
      content: "";
      width: 400px;
      height: 400px;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background-image: url('../assets/images/work/mobile-box.png');
      background-size: cover;
      background-repeat: no-repeat;
    }

    .carousel-inner {
      position: absolute;
      left: 139px;
      top: 12px;
      width: 221px;
      height: 476px;
      background: #fff;
    }


    .left.carousel-control {
      left: 0px;
      z-index: 2;
    }

    .right.carousel-control {
      right: 0px;
      z-index: 2;
    }
  }

  &.mobile-modal {
    .qr-img {
      width: 60%;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }

    .pc-box {
      width: 320px;
      height: 200px;
      background-position: center;

      #pcCarousel {
        width: 219px;
        height: 130px;
        left: 53px;
        top: 20px;
      }
    }

    .mobile-box {
      width: 320px;
      height: 420px;
      margin-bottom: 60px;

      &:after {
        background-position: center;
      }

      .carousel-inner {
        left: 67px;
        top: 10px;
        width: 186px;
        height: 401px;
      }
    }
  }
}
</style>